import { h, JSX } from "preact";

import classname from "../../../foundation/utils/classname";

import TextureBackground from "../TextureBackground";

import styles from "./ColorBlock.module.css";

interface Props extends JSX.HTMLAttributes<HTMLDivElement> {
    color: string;
    colorClass?: string;
}

function ColorBlock({
    class: cssClass,
    colorClass,
    color,
    children,
    ...nativeDivProps
}: Props) {
    return (
        <div class={classname(styles.colorBlock, cssClass)} {...nativeDivProps}>
            <div class={classname(styles.color, colorClass)} style={{ background: color }}/>
            <TextureBackground class={styles.texture} absolute/>
            {children}
        </div>
    );
}

export default ColorBlock;
